import { combineReducers } from "redux";
import * as loginReducer from "../containers/login/reducer";
import * as dashboardReducer from "../containers/dashboard/reducer";
import * as companyDashboardReducer from "../containers/companyDashboard/reducer";
import * as employeeRegistrationReducer from "../containers/employeeConfirmRegistration/reducer";
import * as onBoardCompanyReducer from "../containers/companyRegistration/reducer";
import * as onBoardVendorReducer from "../containers/vendorRegistration/reducer";
import * as reportsReducer from "../containers/reports/reducer";
import * as contactSupportReducer from "../containers/contactSupport/reducer";
import * as featureFlagsReducer from "../containers/featureFlags/reducer";
import { vendorDashboardReducer } from "../containers/vendorDashboard/reducer";
import { engagementReducer } from "../containers/engagement/reducer";

export default combineReducers(
  Object.assign(
    loginReducer,
    dashboardReducer,
    companyDashboardReducer,
    employeeRegistrationReducer,
    onBoardCompanyReducer,
    onBoardVendorReducer,
    reportsReducer,
    contactSupportReducer,
    featureFlagsReducer,
    { vendorDashboardReducer, engagementReducer }
  )
);
